import { create } from 'zustand'
import { normalizeTagId } from '../utils/tagAllocation'

type BirthScanState = {
  rawScans: number
  uniqueTags: string[]
  tagHitCount: Record<string, number>
  ingestTag: (tagId: string) => void
  removeTag: (tagId: string) => void
  clear: () => void
}

/** In-session pool for Engine birth — not shared with Raw Scan. */
export const useBirthScanStore = create<BirthScanState>((set) => ({
  rawScans: 0,
  uniqueTags: [],
  tagHitCount: {},

  ingestTag: (tagId) => {
    const t = normalizeTagId(tagId)
    if (!t) return
    set((s) => {
      const tagHitCount = { ...s.tagHitCount, [t]: (s.tagHitCount[t] ?? 0) + 1 }
      const uniqueTags = s.tagHitCount[t] ? s.uniqueTags : [t, ...s.uniqueTags]
      return {
        rawScans: s.rawScans + 1,
        uniqueTags,
        tagHitCount,
      }
    })
  },

  removeTag: (tagId) => {
    const t = normalizeTagId(tagId)
    if (!t) return
    set((s) => {
      if (!s.tagHitCount[t]) return s
      const { [t]: _removed, ...tagHitCount } = s.tagHitCount
      return {
        uniqueTags: s.uniqueTags.filter((id) => id !== t),
        tagHitCount,
      }
    })
  },

  clear: () => set({ rawScans: 0, uniqueTags: [], tagHitCount: {} }),
}))
